import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Users } from "lucide-react";
import { useAuth, apiErr } from "@/context/AuthContext";
import { AuthShell, inputCls, btnCls } from "@/components/AuthShell";

export default function StaffLogin() {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      if (!["staff", "owner", "admin"].includes(u.role)) {
        await logout();
        setError("This portal is for staff. Please use the client sign-in.");
        return;
      }
      toast.success("Welcome back!");
      navigate(u.role === "staff" ? "/staff" : "/admin");
    } catch (err) { setError(apiErr(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Staff sign in" sub="Masaya staff portal."
      footer={<>Not staff? <Link to="/login" className="text-[#B87333] font-medium hover:underline">Client sign-in</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="staff-login-form">
        <div className="flex items-center gap-2 text-sm text-[#635B52] bg-[#F5F0E8] rounded-xl px-3 py-2"><Users size={16} className="text-[#B87333]" /> Invited staff only</div>
        <div><label className="text-sm font-medium text-[#2C2621]">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="staff-login-email" /></div>
        <div><label className="text-sm font-medium text-[#2C2621]">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="staff-login-password" /></div>
        {error && <p className="text-sm text-red-600" data-testid="staff-login-error">{error}</p>}
        <button type="submit" disabled={loading} className={btnCls} data-testid="staff-login-submit">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
    </AuthShell>
  );
}
